<template>
  <v-col>
    <v-text-field filled dense v-model="search" />
    <v-data-table :items="users" :search="search" :headers="headers">
      <template v-slot:item.action="{item}">
        <v-btn @click="login(item.user_email)" icon small><v-icon>mdi-eye</v-icon></v-btn>
      </template>
    </v-data-table>
  </v-col>
</template>

<script>
import api from "@/api";
export default {
  data: () => ({
    email: null,
    users:[],
    search:null,
  }),
  computed:{
    headers(){
      return [
        {
          text:'email',
          value:'user_email'
        },{
          text:'action',
          value:'action'
        }
      ]
    }
  },
  methods: {
    async getUsers(){
      this.users = await api.users.getAll();
    },
    async login(email) {
      try {
        let login = await api.loginAs(
          email
        );

        // Store token & user informations
        this.$store.dispatch("setToken", login.token);
        let user = await api.users.get(login.user.id_user);
        this.$store.dispatch("setUser", user);
        this.$router.push("/");
      } catch (err) {
        console.error(err);
      }
    },
  },
  mounted(){
    this.getUsers();
  }
};
</script>

<style>
</style>